export default __webpack_public_path__ + "static/media/Rhino_3D.d5e9162f.png";